export const PARTNER_BRANDING_PATH = 'branding/start/';
